<template>
  <div class="box noBtn" style="background: #fff;overflow: auto;" v-if="list.length > 0">
    <!-- 投标人 -->
    <div>
      <table class="show">
        <colgroup width="160px"></colgroup>
        <tr v-for="(item, index) in list" :key="index">
          <td style="width: 350px">{{ item.qymc }}({{ index + 1 }}次报价)</td>
          <td
              v-if="index == list.length - 1 && list[list.length - 1].bjzt == 0"
          >
            <el-input
                type="text"
                v-model="inputPrice"
                placeholder="请输入报价金额"
                oninput="value=value.replace(/[^0-9.]/g, '')"
            >
            </el-input>
          </td>
          <td v-else>{{ item.bjje }}</td>
          <td v-if="index !== 0 && item.fileId">
            <span>{{ item.bjcsmc + '.pdf' }}</span>
            <el-button type="text" @click="download(item)">下载</el-button>
            <el-button type="text" @click="toShowPdfUrl(item)">查看</el-button>
          </td>
        </tr>
      </table>
    </div>
    <!-- 报价单 -->
    <el-dialog
        title="报价单"
        :visible.sync="dialogFormVisible"
        width="680px"
        :close-on-click-modal="false"
    >
      <el-table :data="bjdTable" style="width: 100%" border>
        <el-table-column prop="sort" label="序号" width="80"></el-table-column>
        <el-table-column prop="fileName" label="文件名" width="200"></el-table-column>
        <el-table-column prop="signatureStatus" label="签章状态" width="100">
          <template slot-scope="scope">
            <span v-if="Number(scope.row.signatureStatus) === 0">未签章</span>
            <span v-else>已签章</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-button
                type="text"
                @click="toGetPdfUrl(scope.row)"
            >签章</el-button>
            <el-button
                type="text"
                @click="toShowPdfUrl(scope.row)"
            >查看</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-row type="flex" justify="center" style="margin-top: 10px;">
        <el-button type="primary" @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitPdf">确 定</el-button>
      </el-row>
    </el-dialog>
  </div>
  <div v-else class="loading">
    <p>正在进行有效性审查，请耐心等待...</p>
    <div id="colorfulPulse">
      <span class="item-1"></span>
      <span class="item-2"></span>
      <span class="item-3"></span>
      <span class="item-4"></span>
      <span class="item-5"></span>
      <span class="item-6"></span>
      <span class="item-7"></span>
    </div>
  </div>
</template>

<script>
import { getCaSignUrl } from '@/utils/ca'

export default {
  data() {
    return {
      inputPrice: "",
      list: [],
      lastPrice: "",
      bjcs: "",
      qymc: "",
      scje: "", // 上一次输入的金额
      bjdTable: [],
      dialogFormVisible: false,
      userName: localStorage.getItem("user")
          ? localStorage.getItem("user")
          : "",
      iframeObj: {}
    };
  },
  props: ["djlcId"],
  created() {
    this.getData();
  },
  mounted() {
    window.addEventListener(
        "message",
        function (event) {
          console.log(event.data, "=====event");
          if (event.data.saveSign) {
            this.sendBjjeoverride();
          }
        }.bind(this)
    );
  },
  methods: {
    async getData() {
      let para = { djlcId: this.djlcId };
      // let para = { djlcId: "投标谢大帅" };
      try {
        let res = await this.$api.tbrdcbjquery(para);
        if (res.status == 200) {
          this.list = res.data.data.tbrdcbj;
          let endcode = 0;
          let bjzt = 0;
          if (this.list.length > 0) {
            this.lastPrice = this.list[this.list.length - 1].bjje;
            this.bjcs = this.list[this.list.length - 1].bjcs;
            this.qymc = this.list[0].qymc;
            this.scje = this.list[this.list.length - 2].bjje;
            endcode = this.list[this.list.length - 1].endcode;
            bjzt = this.list[this.list.length - 1].bjzt;
          }
          if (
              (endcode == 0 || endcode == null) &&
              (bjzt == 0 || bjzt == null)
          ) {
            this.$emit("isShow", 0);
          } else {
            this.$emit("isShow", 1);
          }
        } else {
          this.$message({ type: "error", message: res.message });
        }
      } catch (err) {
        console.log("投标人", err);
      }
    },
    tbrDo(lx) {
      if (lx == "hytbbj") {
        this.sendListData();
      }
    },
    async sendBjjeoverride() {
      let para = {};
      para.qymc = this.qymc;
      para.bjje = this.inputPrice;
      para.num = this.bjcs;
      const id = this.bjdTable.length ? this.bjdTable[0].fileId : ''
      try {
        let res = await this.$api.hybjjeoverride(id, para);
        if (res.status == 200) {
          if (res.data.data.status == "false") {
            this.$message({
              type: "error",
              message: "确认时间已过无法提交新报价!",
            });
          }
          this.bjdTable = [res.data.data]
          this.dialogFormVisible = true
          this.getData();
          let obj = {
            lx: "tb",
            data: {
              index: 2,
              msg: "2",
              all: true,
            },
          };
          this.$emit("send", JSON.stringify(obj));
        } else {
          this.$message({ type: "error", message: res.message });
        }
      } catch (err) {
        console.log("投标人-上传报价", err);
      }
    },
    // 提交报价
    async sendListData() {
      if (this.inputPrice == "") {
        this.$message({
          type: "warning",
          message: "请先填写报价",
        });
      } else {
        if (this.bjdTable.length) {
          this.dialogFormVisible = true
          return
        }
        this.sendBjjeoverride();
      }
    },
    async submitPdf() {
      const params = {
        num: this.bjcs,
        qymc: this.qymc,
        bjje: this.inputPrice
      }
      try {
        const res = await this.$api.hyConfirmSign(this.bjdTable[0].fileId, params)
        if (!res.data.meta.success) {
          this.$message.error(res.data.meta.message)
        } else {
          this.$message.success('签章成功')
          this.bjdTable = []
          this.dialogFormVisible = false
          await this.getData()
        }
      } catch (e) {
        console.log(e)
      }
    },
    toShowPdfUrl(data) {
      this.$api.hypdfshow(data.fileId).then(res => {
        const blob = new Blob([res.data], {
          type: "application/pdf;chartset=UTF-8",
        });
        const url = window.URL.createObjectURL(blob); // 创建下载的链接
        window.open(url)
      })
    },
    toGetPdfUrl(data) {
      let para = {
        bizfiledId: data.fileId,
        userName: this.userName,
      };
      this.$api
          .toSign(para)
          .then((res) => {
            window.open(getCaSignUrl(res.data.data))
          })
          .catch((err) => {
            console.log(err);
          });
    },
    download(data) {
      this.$api.hypdfshow(data.fileId).then(res => {
        let fileName = data.bjcsmc
        let blob = new Blob([res.data], {
          type: "application/pdf;chartset=UTF-8",
        });
        if (window.navigator.msSaveOrOpenBlob) {
          navigator.msSaveBlob(blob, fileName);
        } else {
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = fileName;
          link.click();
          //释放内存
          window.URL.revokeObjectURL(link.href);
        }
        this.waitLoading = false;
      })
    }
  },
};
</script>

<style lang='scss' scoped>
</style>
